
import { Component, Vue } from 'vue-property-decorator'

import Spinner from './icons/Spinner.vue'

@Component({
  components: {
    Spinner,
  },
})
export default class Loader extends Vue { }
